import * as R from "ramda";

import {
  FETCH_NEW_MESSAGES,
  CLIENT_CONNECT,
  NEW_MESSAGE,
  MESSAGES_READ,
  DELETE_MESSAGE
} from "../actions/chat";
import { SELECT_COMPANY } from "../actions/company";

const initialState = {
  url: null,
  newMessages: []
};

const messages = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case FETCH_NEW_MESSAGES.RESOLVED:
      return {
        ...state,
        newMessages: payload
      };

    case CLIENT_CONNECT.RESOLVED:
      return {
        ...state,
        url: payload.url
      };

    case NEW_MESSAGE.TYPE:
      return {
        ...state,
        newMessages:
          payload.source === "candidate"
            ? R.append(payload, state.newMessages)
            : state.newMessages
      };

    case MESSAGES_READ.RESOLVED:
      return {
        ...state,
        newMessages: R.reject(
          m =>
            m.idCandidate === payload.idCandidate &&
            m.idOpportunity === payload.idOpportunity,
          state.newMessages
        )
      };

    case DELETE_MESSAGE.TYPE:
      return {
        ...state,
        newMessages: R.reject(
          m =>
            m.idCandidate === payload.idCandidate &&
            m.idOpportunity === payload.idOpportunity,
          state.newMessages
        )
      };

    case SELECT_COMPANY.TYPE:
      return initialState;

    default:
      return state;
  }
};

export default messages;
